import { PillType } from '../components/m-pill/m-pill.component.types';

/**
 * Maps semantic pill variants from BFF to design system PillType
 *
 * This is the ONLY frontend mapping - everything else comes from BFF.
 * BFF sends semantic variants ("success", "warning", "error", "info", "draft")
 * which we map to the design system's PillType enum.
 *
 * @example
 * // BFF sends: { pillVariant: "success" }
 * const pillType = mapPillVariant("success"); // PillType.done
 */
export const PILL_VARIANT_MAP: Record<string, PillType> = {
  success: PillType.done,
  warning: PillType.attention,
  error: PillType.error,
  info: PillType.info,
  draft: PillType.draft
};

/**
 * Map a semantic pill variant from BFF to design system PillType
 * @param variant - Semantic variant from BFF ("success", "warning", "error", "info", "draft")
 * @returns Corresponding PillType enum value
 */
export function mapPillVariant(variant: string): PillType {
  return PILL_VARIANT_MAP[variant] || PillType.draft;
}
